import { render, staticRenderFns } from "./MenuToggleTheme.vue?vue&type=template&id=56c31b81"
import script from "./MenuToggleTheme.vue?vue&type=script&lang=js"
export * from "./MenuToggleTheme.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports